export default {
	methods: 
    {	
		async searchInclusiones(value)
		{
			this.resetDataGet()
			if(value===1)
			{
				await this.getDataGet({route: 'get_inclusionespend', data:{others: []}})
			}
			else 
			{
				await this.getDataGet({route: 'get_inclusioneshist', data: {others: []}})
			}
			
		},
		resetFile()
		{
		  this.uploadReady = false
		  this.$nextTick(() => {
				this.uploadReady = true
		  })		 
		},
		async inputSearchs()
		{
			this.searchsGet =  await this.getData({route: 'get_aflinfoafl', data:  this.searchSw.value })
		},	
		async getFiltrar2()
		{
			await this.getDataGet({ route: 'get_inclusionespend', data: {others: []}})
			// frontend await this.searchGetIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
		},	
		async getFiltrar()
		{
			let dataRoute={}
			let others=[]
			let filterKeys= Object.keys(this.filter);
			for (let i = 0; i < filterKeys.length; i++) {				
				if(this.filter[filterKeys[i]]!==''  && this.filter[filterKeys[i]]!==null)
				{
					others.push([filterKeys[i],this.filter[filterKeys[i]]])
				}	
			}
			dataRoute.others=others
			await this.getDataGet({ route: 'get_inclusioneshist', data: dataRoute})
			// frontend await this.searchGetIdb({tabla:'get_inclusioneshist', campo:'id_datos_afiliado', value: this.filter.id_datos_afiliado[0].id})
		},	
		async getLimpiar()
		{
			this.filter.id_datos_afiliado = null
			await this.getDataGet({ route: 'get_inclusioneshist', data: {others: []}})
			// frontend await this.searchGetIdb({tabla:'get_inclusioneshist', campo:'id_datos_afiliado', value: this.filter.id_datos_afiliado[0].id})
		}
	},
}